import { render, staticRenderFns } from "./ViewPath.vue?vue&type=template&id=2a38b3e3&scoped=true"
import script from "./ViewPath.vue?vue&type=script&lang=js"
export * from "./ViewPath.vue?vue&type=script&lang=js"
import style0 from "./ViewPath.vue?vue&type=style&index=0&id=2a38b3e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38b3e3",
  null
  
)

export default component.exports